import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-toiletnew-page',
  templateUrl: './toiletnew-page.component.html',
  styleUrls: ['./toiletnew-page.component.css'],
})
export class ToiletnewPageComponent implements OnInit {
  private getApi = environment.url + environment.initiativelistGet;
  element: any = []; // Define element object to hold API response

  /**
   * Constructs an instance of the ToiletnewPageComponent.
   * @param route The ActivatedRoute service is used to access the route parameters.
   * @param router The Router service is used to navigate the router.
   * @param location The Location service is used to interact with the browser's URL.
   * @param makeapi The ApiService is used to make API calls.
   * @param valueService The ValueService is used to manage application state.
   */
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private makeapi: ApiService,
    private valueService: ValueService
  ) {}

  /**
   * Lifecycle hook that is called after the component is initialized.
   * It sets the `isVisibleSource` observable to true and watches for changes
   * in the route query parameters. If the `_title` parameter is present,
   * it calls the `viewInitiative2` method to fetch the initiative data.
   */
  ngOnInit(): void {
    // Set the isVisibleSource observable to true
    this.valueService.isVisibleSource.next(true);

    // Watch for changes in the route query parameters
    this.route.queryParams
      .pipe(
        // Filter the query parameters to only consider those with a `_title` key
        filter((params) => params._title)
      )
      .subscribe((params) => {
        // Fetch the initiative data using the provided title
        this.viewInitiative2(params._title);
      });
  }

  showFull = false;
  /**
   * Toggles the visibility of the full content.
   *
   * This function switches the `showFull` boolean flag to show or hide
   * the complete content. When `showFull` is true, the full content is displayed;
   * otherwise, a truncated version is shown.
   */
  toggleFullContent(): void {
    // Toggle the showFull flag between true and false
    this.showFull = !this.showFull;
  }
  expandedId: number | null = null;
  /**
   * Toggles the expansion of the accordion based on the index.
   * @param {number} id The index of the accordion to toggle.
   */
  toggleExpand(id: number): void {
    // Toggle the expandedId flag to show or hide the accordion content
    this.expandedId = this.expandedId === id ? null : id;
  }

  sam1Values = [];
  sam2Values = [];
  sam;
  /**
   * Fetches initiative data from the server using a GET request.
   * Updates the element array with the received data.
   * @param {string} _title The title of the initiative to fetch.
   */
  viewInitiative2(_title: any) {
    // Make API call to fetch initiative data
    this.makeapi
      .method(this.getApi + 'title=' + _title, '', 'getunauth')
      .subscribe((data) => {
        // Update the element array with the response data
        this.element = data;
        // Update the sam array with the initiativesBenefits from the response data
        this.sam = this.element.initiativesBenefits;
      });
  }

  /**
   * Open a link in a new tab.
   *
   * This function is used to open a link in a new tab when the link is clicked.
   * It takes a string parameter `redirectLink` which is the URL of the link to open.
   * The function uses the `window.open` function to open the link in a new tab.
   *
   * @param {string} redirectLink The URL of the link to open.
   */
  linkclick(redirectLink: string): void {
    window.open(redirectLink, '_blank');
  }

  /**
   * Navigate back to the corporate page.
   *
   * This function navigates back to the corporate page when the back button is clicked.
   */
  backBtn(): void {
    // Navigate back to the corporate page
    this.router.navigateByUrl('/ncoporate');
  }

  /**
   * Navigate back to the previous page.
   *
   * This function uses the Location service to navigate back to the previous page.
   * It is called when the back button is clicked.
   */
  backBtn2(): void {
    // Navigate back to the previous page
    this.location.back();
  }
}
